export default {
  // Tilat
  "common.mode.auto": "Automaattinen tila (oma sähköntuotannon käyttö)",
  "common.mode.economy": "Ekonominen tila",
  "common.mode.exigency": "Hätätila",

  // Laitteet
  "common.grid": "Sähköverkko",
  "common.evChargers": "Sähköauton lataajat (useita)",
  "common.evCharger": "Sähköauton lataaja",
  "common.pv": "Aurinkopaneelit (PV)",
  "common.inverter": "Omittaja (sähkövirran muuntolaitteisto)",
  "common.pcs": "Omittaja + akku",
  "common.terminal": "Terminaalilaitteisto",
  "common.airc": "Ilmastointi (AC)",
  "common.engine": "Moottori",
  "common.battery": "Akku",
  "common.metter": "Sähkömittari",
  "common.other": "Muut",
  "common.power": "Teho",
  "common.powerTotal": "Yhteisteho",
  "common.voltage": "Jännite",
  "common.electricity": "Sähkö",
  "common.current": "Virta",
  "common.homeUsage": "Kokonaiskotiinlisä",
  "common.battery.power": "Akun teho",

  // Tiedot
  "common.noDataAvailable": "Tietoja ei ole käytettävissä tällä hetkellä~",
  "common.tips": "Vinkkejä",
  "common.reset": "Nollaa (tyhjennä)",
  "common.currencyUnit": "¥ (yuan)",
  "common.submiting": "Lähetetään... odota hetki...",
  "common.close": "Sulje",
  "common.from": "Lähteestä",
  "common.useIn": "Käyttöön",
  "common.energyPercent": "Energian käyttöaste",
  "common.dataFlow": "Tietovirta",
  "common.getDataIng": "Haetaan tietoja... odota hetki...",
  "common.pageLoading": "Ladataan sivua... odota hetki...",
  "common.reseting": "Nollataan sivua... odota hetki...",
  "common.save": "Tallenna",
  "common.onlyNumberTips": "Voit syöttää vain numeroita",
  "common.offline": "Offline (ei internetyhteyttä)",
  "common.online": "Online (internet-yhteys)",
  "common.fault": "Virhe (ongelma)",
  "common.charge": "Lataa (akku)",
  "common.discharge": "Luovuta virta (akun energian käyttö)",
  "common.buy": "Osta",
  "common.sell": "Myy",
  "common.loadingInfo": "Ladataan... odota hetki...",

  // Yleiset toiminnot
  "common.moreFeatures": "Lisää toimintoja",
  "common.confirm": "Vahvista",
  "common.saveing": "Tallennetaan... odota hetki...",
  "common.searchPlacholder": "Syötä hakusana",
  "common.iSee": "Ymmärrän",
  "common.pageErrorTips1": "Oh no, sivulla tapahtui virhe~",
  "common.pageErrorTips2": "Päivitä sivu tai ota yhteyttä tukeen~",
  "common.refresh": "Päivitä",
  "common.backToHome": "Palaa etusivulle",
  "common.checkTips": "Tarkistetaan... odota hetki...",
  "common.back": "Palaa",
  "common.cancel": "Peruuta (poista)",
  "common.optional": "Valinnainen (ei pakollinen)",
  "common.required": "Pakollinen syöttää",
  "common.status": "Tila",
  "common.statusNoDelete": "Ei poistettu",
  "common.statusDelete": "Poistettu",
  "common.submit": "Lähetä",
  "common.disable": "Poista käytöstä",
  "common.enable": "Ota käyttöön",
  "common.year": "Vuosi",
  "common.month": "Kuukausi",
  "common.day": "Päivä",
  "common.version": "Versio:",
  "common.backHome": "Palaa etusivulle",
  "common.backHomeSorry": "Valitettavasti tämä sivu on virheellinen",
  "common.requestTips1": "Tietojen haku on käynnissä, älä lähetä uudelleen",
  "common.requestTips2": "Järjestelmän ilmoitukset",
  "common.requestTips3": "Kirjautumissessio on vanhentunut, kirjaudu uudelleen",
  "common.requestTips4": "Kirjaudu uudelleen",
  "common.requestTips5": "Kirjautus on virheellinen tai sessio on vanhentunut, kirjaudu uudelleen.",
  "common.requestTips6": "Palvelinvirhe, yritä myöhemmin uudelleen.",
  "common.requestTips7": "Järjestelmän pyynnön aikakatkaisu",
  "common.requestTips8": "Järjestelmän käyttöliittymä",
  "common.requestTips9": "Virhe",
  "common.iknow": "Ymmärrän",
  "common.logoutSuccess": "Kirjauduttu ulos onnistuneesti",
  
  // Lisätietoja-osio
  "common.knowMore.title": "Lisätietoja varten ota yhteyttä Beinengiin",
  "common.knowMore.email": "Sähköposti yhteydenottoon",
  "common.knowMore.phone": "Puhelinnumero yhteydenottoon",
  "common.knowMore.wechat": "WeChat yhteydenottoon",
  "common.knowMore.website": "Virallinen verkkosivusto-osoite",
  "common.knowMore.address": "Osoite yhteydenottoon",
  "common.knowMore.addressDetail": "Yksikkö 1205, 1301, Rakennus 5, Qingxi 8 -tie, Huangjingkeng -kylä, Huangjiang -kaupunki, Dongguan -kaupunki, Guangdong -provinssi",
  
  // Lokaali yhteys
  "common.localConnection": "Lokaali yhteys",
  "common.operateInApp": "Suorita toimintoja sovelluksessa!",
  
  "common.enbleStaus": "Käytössä oleva tila",
  "common.battery.status": "Ei latausta, ei virtaluovutusta",

  // Tilin liittyvät asiat
  "account.forgetThePassword": "Unohtunut salasana",
  "account.logInDirectly": "Suora kirjautus",
  "account.tips1": "Siirrytään sivulle... odota hetki...",
  "account.tips2": "Lue ja hyväksy ensin käyttöehdot!",
  "account.autoLogin": "Automaattinen kirjautus",
  "account.userLogin": "Käyttäjän kirjautus",
  "account.registerTips": "Ei tiliä? Klikkaa tästä rekisteröityäksesi",
  "account.userEmail": "Käyttäjätunnus / sähköposti",
  "account.userEmailTips": "Syötä käyttäjätunnus tai sähköposti",
  "account.password": "Salasana",
  "account.passwordTips": "Syötä salasana",
  "account.submit": "Lähetä",
  "account.submitTips": "Lähetetään... odota hetki...",
  "account.otherLoginTips": "Tai valitse toinen kirjautustapa",
  "account.userRegistration": "Käyttäjän rekisteröinti",
  "account.userName": "Käyttäjätunnus",
  "account.userNameTips": "Syötä käyttäjätunnus",
  "account.emailTips1": "Syötä sähköpostiosoite",
  "account.emailTips2": "Virheellinen sähköpostimuoto",
  "account.phone": "Puhelin",
  "account.phoneTips1": "Syötä puhelinnumero",
  "account.phoneTips2": "Virheellinen puhelinnumero",
  "account.phoneTips3": "Syötä puhelinnumero",
  "account.passwordTips1": "Syötä salasana (6-30 merkkiä)",
  "account.passwordTips2": "Virheellinen salasanamuoto: Salasanassa tulee olla englantilaisia kirjaimia, numeroita, alaviivaa (_), viivaa (-) ja pistettä (.), pituus 6-12 merkkiä",
  "account.passwordTips3": "Kaksi syötettyä salasanaa eivät täsmää, tarkista ja syötä uudelleen!",
  "account.passwordTips4": "Syötä salasana: Salasanassa tulee olla englantilaisia kirjaimia, numeroita, alaviivaa (_), viivaa (-) ja pistettä (.)",
  "account.passwordTips5": "Salasanan vahvistus",
  "account.passwordTips6": "Syötä salasanan vahvistukseksi",
  "account.passwordTips7": "Kaksi syötettyä salasanaa eivät täsmää, tarkista ja syötä uudelleen!",
  "account.passwordTips8": "Syötä salasanan vahvistukseksi",
  "account.passwordTips9": "Onnittelut, rekisteröinti onnistui!",
  "account.passwordTips10": "Sinun käyttäjätunnuksesi on:",
  "account.emailIs": "Sinun sähköpostisi on:",
  "account.goToLoginPage": "Siirrytään automaattisesti kirjautussivulle s sekunnin kuluttua",
  "account.goLogin": "Kirjaudu",
  "account.goRegister": "Rekisteröidy",
  "account.loginSuccess": "Kirjautus onnistui",
  "account.email": "Sähköposti",
  "account.sologn": "Luomme integroituja energiaplatformeja, jotka on suunniteltu erityisesti sinulle",
  "account.pleaseAgree": "Olen lukenut ja hyväksynyt",
  "userAgreement.privacyPolicy": "Tietosuojaa koskevat säännöt",

  // Vahvistuskoodin liittyvät asiat
  "account.code": "Vahvistuskoodi",
  "account.codeTips": "Syötä vahvistuskoodi",
  "account.codeTips2": "Virheellinen vahvistuskoodi",

    "account.inviteCodeTips": "Syötä kutsukoodi",
    "account.inviteCodeHint": "Ota yhteyttä asentajaan tai huoltohenkilöstöön saadaksesi kutsukoodin",
  // Salasanan muutos ja palautus
  "account.modifyPasswordByAccount": "Muuta salasanaa tilin kautta",
  "account.modifyPasswordByEmail": "Muuta salasanaa sähköpostin kautta",
  "account.getPasswordByAccount": "Hae salasanaa tilin kautta",
  "account.getPasswordByEmail": "Hae salasanaa sähköpostin kautta",

  "account.sendEmailTips": "Vahvistuskoodi on lähetetty sähköpostiin, tarkista se",
  "account.name": "Tilin nimi",
  "account.newPassword": "Uusi salasana",
  "account.confirmNewPassword": "Uuden salasanan vahvistus",
  "account.nameTips": "Syötä tilin nimi",
  "account.passwordModifySuccess": "Salasanan muutos onnistui",
  "account.emailCode": "Sähköpostivahvistuskoodi",
  "account.emailCodeTips": "Syötä sähköpostivahvistuskoodi",
  "account.emailCodeTips2": "Virheellinen sähköpostivahvistuskoodi",
  "account.emailModifySuccess": "Salasanan muutos onnistui",
  "account.passworTips1": "Salasanasi on palautettu!",
  "account.passwordTips11": "Syötä salasanan vahvistukseksi",
  "account.passwordTips12": "Syötä uusi salasana",
  "account.nickname": "Nimimerkki",
  "account.modifyNickname": "Muuta nimimerkkiä",
  "account.modifyNicknameSuccess": "Nimimerkin muutos onnistui!",
  "account.nicknameTips": "Syötä nimimerkki",
  "account.nicknameError": "Nimimerkin muutos epäonnistui!",

  // Nopea rekisteröinti ja kirjautus
  "account.login": "Kirjaudu",
  "account.quickRegister": "Nopea rekisteröinti",
  "account.sendCode": "Lähetä koodi",
  "account.sendTips": "Voit lähettää uudelleen s sekunnin kuluttua",
  "account.sendEmailIng": "Lähetetään sähköpostia... odota hetki...",
  "account.emailNotEmpty": "Sähköpostikenttä ei voi olla tyhjä",
  "account.registerAccount": "Tilin rekisteröinti",
  "account.registerWelcome": "Tervetuloa SusprSafe-rekisteröintiin",
  "account.usernameLimit": "Käyttäjätunnuksen on aloitettava kirjaimella, se voi sisältää vain kirjaimia, numeroita ja alaviivaa (_), pituus 5-15 merkkiä",

  // Tekijänoikeustiedot
  "copyright.desc2": "Verkkosivuston rekisteröintitiedot: Guangdongin provinssin ICP-rekisteröinnin numero 2021169764",

  // Käyttäjän tietojen muokkaus
  "editUserInfo.editUserInformation": "Muokkaa käyttäjän tietoja",
  "editUserInfo.modifyUsername": "Muuta käyttäjätunnusta",
  "editUserInfo.changePictures": "Vaihda profiilikuvaa",
  "editUserInfo.savePicturesSuccess": "Profiilikuvan tallennus onnistui",
  "editUserInfo.saveError": "Tallennus epäonnistui",
  "editUserInfo.pictureLimit": "Kuvan koko ei voi ylittää 2 MB",
  "editUserInfo.uploadPicture": "Lataa profiilikuva",
  "editUserInfo.picturePreview": "Esikatselu",
  
  "editUserInfo.bindPhoneNumber": "Liitä puhelinnumero",
  "editUserInfo.bindEmail": "Liitä sähköposti",
  "editUserInfo.changePassword": "Muuta salasana",

  "editUserInfo.notificationSettings": "Ilmoitusasetukset",
  "editUserInfo.editAccount": "Muokkaa tilin tietoja",
  "editUserInfo.waitBingting": "Liitetään... odota hetki...",
  "editUserInfo.collapse": "Sulje (erota)",
  "editUserInfo.modifyBinding": "Muuta liitosta",
  
  "editUserInfo.emailAddress": "Sähköpostiosoite",
  "editUserInfo.tips1": "Sähköpostin liittäminen onnistui",
  "editUserInfo.tips2": "Tallennus epäonnistui",
  "editUserInfo.tips3": "Lähetetään sähköpostivahvistuskoodia... odota hetki...",
  "editUserInfo.tips4": "Vahvistuskoodi on lähetetty sähköpostiin xxxx, tarkista se",
  "editUserInfo.tips5": "Vahvistuskoodin lähetys epäonnistui!",
  "editUserInfo.tips6": "Puhelinnumero on liitetty",
  "editUserInfo.tips7": "Sähköposti on liitetty",
  "editUserInfo.emailTips1": "Syötä sähköpostiosoite",
  "editUserInfo.emailTips2": "Virheellinen sähköpostimuoto",
  "editUserInfo.emailTips3": "Voit lähettää uudelleen xxxx sekunnin kuluttua",
  "editUserInfo.emailTips4": "Lähetä koodi",
  "editUserInfo.emailTips5": "Sähköpostivahvistuskoodikenttä ei voi olla tyhjä",
  "editUserInfo.emailTips6": "Virheellinen sähköpostivahvistuskoodi",
  "editUserInfo.emailCode": "Sähköpostivahvistuskoodi",
  "editUserInfo.save": "Tallenna",

  // Puhelinliitoksen liittyvät asiat
  "editUserInfo.phoneTips1": "Puhelinnumeron liittäminen onnistui",
  "editUserInfo.phoneTips2": "Lähetetään SMS-vahvistuskoodia... odota hetki...",
  "editUserInfo.phoneTips3": "SMS-vahvistuskoodi on lähetetty numeroon xxxx, tarkista se",
  "editUserInfo.phoneTips4": "SMS-vahvistuskoodin lähetys epäonnistui!",
  "editUserInfo.phoneTips5": "Syötä puhelinnumero",
  "editUserInfo.phoneTips6": "Virheellinen puhelinnumeromuoto",
  "editUserInfo.phoneTips7": "Lähetä SMS-vahvistuskoodi",
  "editUserInfo.phoneTips8": "SMS-vahvistuskoodi",
  "editUserInfo.phoneTips9": "SMS-vahvistuskoodikenttä ei voi olla tyhjä",
  "editUserInfo.phoneTips10": "Virheellinen SMS-vahvistuskoodi",
  "editUserInfo.phone": "Puhelinnumero",


  // Ilmoitusasetukset
  "editUserInfo.noticeTips1": "Ilmoitusasetusten haku epäonnistui!",
  "editUserInfo.noticeTips2": "Ilmoitusasetusten tallennus onnistui!",
  "editUserInfo.noticeTips3": "Ilmoitus akun alhaisesta virrasta",
  "editUserInfo.noticeTips4": "Ilmoitus latauksen valmistumisesta",
  "editUserInfo.errorNotification": "Virheilmoitus",
  "editUserInfo.updateNotification": "Päivitysilmoitus",
  "editUserInfo.monthlyStatisticsNotification": "Kuukausistatistiikkailmoitus",
  "editUserInfo.notificationMethod": "Vastaanottotapa",

  // Käyttäjätunnukseen liittyvät vinkkejä
  "editUserInfo.userNameTips1": "Käyttäjätunnuksen tallennus onnistui",
  "editUserInfo.userNameTips2": "Käyttäjätunnuksen tallennus epäonnistui",
  "editUserInfo.userNameTips3": "Syötä käyttäjätunnus",
  "editUserInfo.userNameTips4": "Virheellinen käyttäjätunnusmuoto: Voi sisältää vain numeroita, alaviivaa (_) ja englantilaisia kirjaimia",
  "editUserInfo.userNameTips5": "Syötä käyttäjätunnus",
  "editUserInfo.userNameTips6": "Tallennetaan... odota hetki...",
  "editUserInfo.userName": "Käyttäjätunnus",

  // Profiilikuvan muokkausvinkkejä
  "editUserInfo.avatorTips": "Klikkaa vaihtamaan profiilikuvaa",
  "editUserInfo.verifyCodeTips1": "Syötä vastaanotettu vahvistuskoodi:",
  "editUserInfo.verifyCodeTips2": "Tilin turvallisuuden vuoksi klikkaa alla olevaa nappia lähettääksesi vahvistuskoodin alkuperäiseen puhelinnumeroon:",
  "editUserInfo.verifyCodeTips3": "Lähetä koodi",
  "editUserInfo.verifyCodeTips4": "Alkuperäisen puhelinnumeron vahvistus onnistui, syötä uusi puhelinnumero liittämistä varten",
  "editUserInfo.verifyCodeTips5": "Tilin turvallisuuden vuoksi klikkaa alla olevaa nappia lähettääksesi vahvistuskoodin alkuperäiseen sähköpostiin:",
  "editUserInfo.verifyCodeTips6": "Alkuperäisen sähköpostin vahvistus onnistui, syötä uusi sähköposti",
  "editUserInfo.verifyCodeTips7": "Vanha salasana",
  "editUserInfo.verifyCodeTips8": "Liitä ensin sähköposti!",
  "editUserInfo.verifyCodeTips9": "Vahvistuskoodi on lähetetty sähköpostiin, tarkista se",
  "editUserInfo.verifyCodeTips10": ", siirrytään automaattisesti kirjautussivulle",

  // Ilmoitukseen liittyvät asiat
  "hems.notice.title": "Ilmoituksen otsikko", 
  "hems.notice.content": "Ilmoituksen sisältö", 
  "hems.notice.operate": "Toiminto",
  "hems.notice.noRead": "Lukematon",
  "hems.notice.read": "Luettu",
  "hems.notice.warning": "Varoitus",
  "hems.notice.error": "Virhe",
  "hems.notice.success": "Tilastojen laskenta",
  "hems.notice.sys": "Järjestelmätiedot",
  "hems.notice.operateSuccess": "Toiminto onnistui",
  "hems.notice.operateTips": "Valitse toimintoa varten elementti",

  // Etusivu
  "hems.home.selfuseRate": "Omankäyttöaste",
  "hems.home.percent": "Prosentti",
  "hems.home.todayData": "Tämän päivän tiedot",
  "hems.home.todayPowerGeneration": "Tämän päivän sähköntuotanto",
  "hems.home.salesIncome": "Tulot sähkön myynnistä",
  "hems.home.saved": "Olet säästänyt",
  "hems.home.reduce": "Hiilidioksidipäästöjen vähentäminen",
  "hems.home.tips1": "Tietoja ei ole käytettävissä tällä hetkellä, et ole vielä liittänyt xxxx:ää",
  "hems.home.criticalLoad": "Kriittinen kuorma",
  "hems.home.keyVoltage": "Kriittinen jännite",
  "hems.home.householdLoad": "Kotikuorma",
  "hems.home.householdVoltage": "Kotijännite",
  "hems.home.generalLoad": "Yleiskuorma",
  "hems.home.generalVoltage": "Yleisjännite",
  "hems.home.batteryHealth": "Akun tila",
  "hems.home.averageTemp": "Keski lämpötila",
  "hems.home.gridLoad": "Sähköverkon kuorma",
  "hems.home.toggeleDataSource": "Näytetyt tiedot on muutettu seuraavasti:",
  "hems.home.toggleTips": "Haluatko muuttaa?",
  "hems.home.modeSending": "Lähetetään tilakomentoa... odota hetki...",
  "hems.home.modeSuccess": "Tilan muutos lähetettiin onnistuneesti!",
  "hems.home.isOnline": "Oletko online?",
  "hems.home.useStatus": "Käyttötila",
  "hems.home.workModeText": "Nykyinen työtila:",
  "hems.home.toggleDataSourceText": "Näytetyt tiedot on muutettu seuraavasti:",
  "hems.ev.charge.status": "Lataustila",
  "hems.ev.charge.time": "Latausaika",
  "hems.ev.charge.count": "Toteutunut latausmäärä (aikajana)",
  "hems.ev.charge.status.empty": "Tyhjä",
  "hems.ev.charge.status.ing": "Liitetty akkuun. Ladataan",
  "hems.ev.charge.status.null": "Liitetty akkuun, mutta ei ladata",
  "hems.ev.charge.status.error": "Virhe",
  "hems.hour": "Tunti",
  "hems.minue": "Minuutti",
  "hems.ev.chagre.number": "Lataajan numero",

  // Käyttäjäopas
  "hems.userGuide.selfUse": "Omankäyttö omaan sähköntuotantoon",
  "hems.userGuide.selfUseTips": "Käytä ensin aurinkosähköä, jos se ei ole riittävä, täydennä sähköverkolla",
  "hems.userGuide.economyMode": "Ekonominen tila",
  "hems.userGuide.economyModeTips": "Optimalisoi energiankäyttöstrategia sähkön hintojen perusteella",
  "hems.userGuide.emergencyMode": "Hätätila",
  "hems.userGuide.emergencyModeTips": "Priorisoi energiantarjonta kriittisille kuormille",

  // Grafiikkasivu
  "hems.history.energyStatistics": "Energiatilastot",
  "hems.history.revenueStatistics": "Tulostilastot",
  "hems.history.greenStatistics": "Vihreän päästön vähentäminen",
  "hems.history.revenueTitle": "Yhteistulot sähkön myynnistä",
  "hems.history.savingsTitle": "Yhteissäästöt",
  "hems.history.carbonTitle": "Yhteishiileen vähentäminen",
  "hems.history.day": "Päivä",
  "hems.history.month": "Kuukausi",
  "hems.history.year": "Vuosi",
  "hems.history.beforeDay": "Edellinen päivä",
  "hems.history.afterDay": "Seuraava päivä",
  "hems.history.beforeMonth": "Edellinen kuukausi",
  "hems.history.afterMonth": "Seuraava kuukausi",
  "hems.history.beforeYear": "Edellinen vuosi",
  "hems.history.afterYear": "Seuraava vuosi",
  "hems.history.totalUse": "Yhteiskäyttö",
  "hems.history.fullScreen": "Koko ruutu",
  "hems.history.timeSelect": "Valitse päivä",
  "sync.tips1": "Tietojen synkronointikomento lähetettiin onnistuneesti!",
  "sync.tips2": "Tietojen synkronointi on käynnissä, se vie aikaa suuren datamäärän vuoksi, tarkista uudelleen 50 minuutin kuluttua~",
  "sync.tips3": "Laiteen tietojen synkronointi voi olla viivästynyt, jos huomaat tietojen epätäsmää, klikkaa alla olevaa nappia:",
  "sync.tips4": "Synkronoi tiedot",

  // Lataajan tiedot
  "charge.info": "Lataajan tiedot",
  "news.loading": "Ladataan...",
  "news.noMore": "Ei lisää tietoja",
  "hems.pv.power": "Aurinkosähkön määrä",

  // UEH:n erityistoiminnot
  "ueh.sellPower": "Myydyn sähkön määrä",
  
  // Valikko
  "menu.home": "Etusivu",
  "menu.history": "Historiatiedot",
  "menu.device": "Laitteet",
  "menu.settings": "Asetukset",
  "menu.messageCenter": "Viestikeskus",
  "menu.help": "Ohje ja tuki",
  "menu.mine": "Minä (henkilökohtainen)",


  // Omat asetukset
  "mine.userSetting": "Käyttäjän asetukset",
  "mine.terminalSetting": "Perusterminaalasetukset",
  "mine.uploadCloud": "Lataa tiedot pilveen",
  "mine.changeVersion": "Tarkista päivitykset",
  "mine.language": "Vaihda kieli",
  "mine.about": "Tietoja sovelluksesta",
  "mine.feedback": "Palaute",
  "mine.logout": "Kirjaudu ulos",
  "mine.logoutAccount": "Poista tili",

  // Tilan poistoon liittyvät asiat
  "mine.logoutAccountTips": "Poista tila nimellä []",
  "mine.logoutAccountTips1": "Poista tila, joka on liitetty []:ään",
  "mine.logoutAccountCare": "Huomautuksia tilan poistopyynnöstä:",
  "mine.logoutAccountCare1": "1. Tili on turvallisessa tilassa",
  "mine.logoutAccountCare1-1": "Tili on tavalliseen käyttöön asetettu, ei varkauden, sääntöjen rikkomisen tai sulkemisen riskiä",
  "mine.logoutAccountCare2": "2. Tilaoikeudet ja liitokset poistetaan",
  "mine.logoutAccountCare2-1": "Kaikki kolmannen osapuolen alustojen tilaoikeudet poistetaan",
  "mine.logoutAccountCare3": "3. Poiston jälkeen tilaa ei voi palauttaa, käyttäjän tiedot poistetaan",
  "mine.logoutAccountCare3-1": "Poiston jälkeen liitetyt puhelinnumerot, sähköpostit ja liittyvät tiedot poistetaan eikä niitä voi palauttaa",
  "mine.confirmLogout": "Vahvista poisto",
  "mine.logoutSuccess": "Tila poistettiin onnistuneesti!",


  // Palauteongelmat
  "mine.feedbackIssues": "Ongelmat ja palaute",
  "mine.feedQuantity": "Määrä",
  "mine.feedAmount": "Enintään 9 kuvaa, jokaisen kuvan enimmäiskoko 1 MB",

  // Ilmoitusasetuksiin liittyvät asiat
  "mine.notice.fail": "Ilmoitusasetusten haku epäonnistui!",
  "mine.notice.saveSuccess": "Ilmoitusasetusten tallennus onnistui!",
  "mine.notice.saveFail": "Tallennus epäonnistui!",
  "mine.notice.title": "Ilmoitusasetukset",
  "mine.notice.batteryLow": "Ilmoitus akun alhaisesta virrasta",
  "mine.notice.chargingFinish": "Ilmoitus latauksen valmistumisesta",
  "mine.notice.error": "Virheilmoitus",
  "mine.notice.update": "Päivitysilmoitus",
  "mine.notice.monthly": "Kuukausistatistiikkailmoitus",
  "mine.notice.receiveType": "Vastaanottotapa",

  // Tervetuloa kieliasetuksiin
  "mine.language.welcome": "Tervetuloa SusprSafe:ään",
  "mine.language.desc1": "Valitse kieliversio kotiosoitteesi perusteella",
  "mine.language.desc2": "Voit vaihtaa sitä milloin tahansa sovelluksen asetuksissa",

  // Henkilökohtaiset tiedot
  "mine.userInfo.avatar": "Profiilikuva",
  "mine.userInfo.nickname": "Nimimerkki",
  "mine.userInfo.password": "Salasana",
  "mine.userInfo.changePassword": "Muuta salasana",
  "mine.userInfo.setPassword": "Aseta salasana",
  "mine.userInfo.phoneNumber": "Puhelinnumero",
  "mine.userInfo.bindPhone": "Liitä puhelin",
  "mine.userInfo.bindEmail": "Liitä sähköposti",
  "mine.loginExpired": "Kirjautumissessio on vanhentunut, kirjaudu uudelleen",
  "mine.userInfo.title": "Käyttäjän tiedot",
  "mine.userInfo.bind": "Liitä",
  "mine.userInfo.modify": "Muokkaa",
  "mine.userInfo.modifyNickname": "Muuta nimimerkkiä",
  "mine.userInfo.userNickname": "Käyttäjän nimimerkki",
  "mine.userInfo.selectPic": "Valitse kuva latausta varten",
  "mine.userInfo.saveSuccess": "Tallennus onnistui",
  "mine.userInfo.uploadFail": "Lataus epäonnistui",
  "mine.userInfo.avatarSaveSuccess": "Profiilikuvan tallennus onnistui",
  "mine.userInfo.nameTips1": "NimimerkkiKenttä ei voi olla tyhjä",
  "mine.userInfo.nameTips2": "Syötä nimimerkki"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};